var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.747,
    height: 88.747,
    viewBox: "0 0 88.747 88.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    d: "M44.381.008A44.374,44.374,0,1,0,88.755,44.381,44.375,44.375,0,0,0,44.381.008Zm0,13.268A14.678,14.678,0,1,1,29.706,27.953,14.678,14.678,0,0,1,44.381,13.276Zm-.01,63.877a32.564,32.564,0,0,1-21.206-7.82,6.253,6.253,0,0,1-2.195-4.756,14.8,14.8,0,0,1,14.874-14.8h17.08a14.781,14.781,0,0,1,14.85,14.8,6.242,6.242,0,0,1-2.195,4.754A32.554,32.554,0,0,1,44.372,77.153Z",
    transform: "translate(-0.008 -0.008)",
    fill: "#dedede"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.9d83d87507eacec949863d2a217ef9f8.svg";
export { ForwardRef as ReactComponent };